import { create } from "zustand";

interface MicPermissionState {
  micPermissionDenied: boolean;
  setMicPermissionDenied: (denied: boolean) => void;
  micMuted: boolean;
  setMicMuted: (muted: boolean) => void;
  // True when the mic is unavailable for any reason (permission denied OR muted)
  micUnavailable: boolean;
  // Toast visibility prompted by an all-zero turn. Silence detection sets this
  // true; toast actions (test/dismiss) clear it.
  silenceToastVisible: boolean;
  setSilenceToastVisible: (visible: boolean) => void;
  // Registered by useMicrophone when a session is active; null otherwise.
  // Calling it reinits the audio graph with the newly-saved deviceId.
  reinitForDeviceChange: (() => void) | null;
  setReinitForDeviceChange: (fn: (() => void) | null) => void;
}

export const useMicPermissionStore = create<MicPermissionState>((set) => ({
  micPermissionDenied: false,
  setMicPermissionDenied: (denied) =>
    set((s) => ({
      micPermissionDenied: denied,
      micUnavailable: denied || s.micMuted,
    })),
  micMuted: false,
  setMicMuted: (muted) =>
    set((s) => ({
      micMuted: muted,
      micUnavailable: s.micPermissionDenied || muted,
    })),
  micUnavailable: false,
  silenceToastVisible: false,
  setSilenceToastVisible: (visible) => set({ silenceToastVisible: visible }),
  reinitForDeviceChange: null,
  setReinitForDeviceChange: (fn) => set({ reinitForDeviceChange: fn }),
}));
